export function isRuntimeFlagEnabled(value: unknown): boolean {
  return value === true || value === 'true';
}
